<template>
  <div class="layout-history-list-header">
    <div class="header-left">{{title}}</div>
    <div class="header-right">
      <i class="el-icon-close" @click="onClose"></i>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number
      },
      title: {
        type: String
      }
    },
    data() {
      return {

      }
    },
    methods: {
      onClose () {
        this.$emit('close')
      },
      onReadChange (val) {
        if (val !== this.value) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
 .layout-history-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;
    min-height: 52px;
    border-bottom: 1px solid #E9E8ED;
    .header-left {
      color: rgba(69, 60, 90, 1);
      font-size: 16px;
      font-weight: 600;
      margin-left: 16px;
    }
    .header-right {
      display: flex;
      align-items: center;
      .el-icon-close {
        font-size: 14px;
        margin: 0 13px 0 20px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/drawer/drawer-header.vue